import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import { hasPendingChatConfirmation } from '@terra/ui-design-system';
import {
  mergeChatHistoryAfterResumeIdle,
  shouldRefetchChatHistoryAfterResumeIdle,
} from '@terra/shared-utils';
import { loadChatHistoryPage } from './chatHistoryStore';
import {
  applyUserMessagePlacements,
  isBackgroundTurnShellId,
  readUserMessagePlacements,
} from './copilot-pending-follow-up';

export const settleChatStreamResumeIdle = async ({
  response,
  getMessages,
  threadId,
  setMessages,
}: {
  response: Response;
  getMessages: () => TerraUIMessage[];
  threadId: string;
  setMessages: (messages: TerraUIMessage[]) => void;
}): Promise<void> => {
  if (
    !shouldRefetchChatHistoryAfterResumeIdle({
      resumeStatus: response.status,
      hasPendingConfirmation: hasPendingChatConfirmation(getMessages()),
    })
  ) {
    return;
  }

  const page = await loadChatHistoryPage({ threadId });

  if (!page?.history.length) {
    return;
  }

  setMessages(
    applyUserMessagePlacements({
      messages: mergeChatHistoryAfterResumeIdle({
        pageHistory: page.history,
        localMessages: getMessages().filter(
          (message) => !isBackgroundTurnShellId(message.id),
        ),
      }),
      predecessorIdsByMessageId: readUserMessagePlacements(threadId),
    }),
  );
};
